import {useContext, useEffect, useRef, useState} from "react";
import {
    useHistory, useLocation,
} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";
import {RuoliContext} from "../../context/RuoliContext";
import {TranslateContext} from "../../context/TranslateContext";
import {getAnni, STANDARD_CARBON, STANDARD_ESRS} from "../../utility/common";
import {MobileContext} from "../../context/MobileContext";
import NsMenuView from "./NsMenuView";
import NsMenuStart from "./components/NsMenuStart";
import NsMenuEnd from "./components/NsMenuEnd";
import {ParametersContext} from "../../context/ParametersContext";

export default function NsMenuController() {

    const [anni, setAnni] = useState();
    const [showCarbonFootprint, setShowCarbonFootprint] = useState(false);
    const [showEsrs, setShowEsrs] = useState(false);

    const {user, annoKpi, setAnnoKpi, annoCorrenteDefault} = useContext(AuthContext);
    const {isRuoloAdmin, isRuoloSuperAdmin} = useContext(RuoliContext);
    const {setLingua, translate} = useContext(TranslateContext);
    const {isMobile} = useContext(MobileContext);
    const {getParameterValue, updateParameterCount} = useContext(ParametersContext);

    const history = useHistory();
    const refMenuUsr = useRef();
    const location = useLocation();

    async function getCarbonFootprint() {
        let standards = await getParameterValue('StandardGestiti');
        setShowCarbonFootprint(standards.includes(STANDARD_CARBON));
        setShowEsrs(standards.includes(STANDARD_ESRS));
    }

    async function getParametri() {
        let annoInizio = await getParameterValue('AnnoInizio');

        //imposto come anno di inizio nel menù a tendina, quello di inizio Raccolta Dati ed in più i due precedenti
        let annoInizio_MenuMenoDue = parseInt(annoInizio) - 2;
        setAnni(getAnni(annoInizio_MenuMenoDue, 1));

        if (annoCorrenteDefault) {
            let meseCambioAnno = await getParameterValue('MeseInizio');

            let annoCorrente = new Date().getFullYear();
            let meseCorrente = new Date().getMonth();
            let meseCorrenteR = parseInt(meseCorrente) + 1; //incremento di 1 perchè la valorizzazione parte da zero [returns the month (0 to 11)]

            if (parseInt(meseCorrenteR) < parseInt(meseCambioAnno)) {
                let annoPrecedente = parseInt(annoCorrente) - 1;
                setAnnoKpi(annoPrecedente);
            } else {
                setAnnoKpi(annoCorrente);
            }
        }

        getCarbonFootprint();
    }

    useEffect(() => {
        if (user && updateParameterCount >= 1) {
            getParametri();
        }
    }, [user, updateParameterCount]);

    function isLoginPage() {
        return ['/', '/login'].includes(location.pathname)
    }

    function aggiornaLingua(lingua) {
        setLingua(lingua);
    }

    function onChangeAnno(event) {
        setAnnoKpi(event.target.value);
    }

    const start = <NsMenuStart/>;

    const end = <NsMenuEnd
        user={user}
        isMobile={isMobile}
        aggiornaLingua={aggiornaLingua}
        annoKpi={annoKpi}
        anni={anni}
        refMenuUsr={refMenuUsr}
        onChangeAnno={onChangeAnno}
    />;

    const itemRendererMenubar = (item) => (
        <a className="flex align-items-center p-menuitem-link">
            <span className={item.icon}/>
            <span className="mx-2">{item.label}</span>
        </a>
    );

    function goTo(rotta) {
        history.push(rotta);
    }

    return (
        !isLoginPage() &&
        <NsMenuView
            translate={translate}
            user={user}
            itemRendererMenubar={itemRendererMenubar}
            isRuoloSuperAdmin={isRuoloSuperAdmin}
            end={end}
            isRuoloAdmin={isRuoloAdmin}
            start={start}
            goTo={goTo}
            showCarbonFootprint={showCarbonFootprint}
            showEsrs={showEsrs}
        />
    );
}
